<script setup lang="ts">
import type { GemXOptionSelects } from './types';

import { useCampaignThemePage } from '../../hooks/useCampaignThemePage';
import { useVariantThemePage } from '../../hooks/useVariantThemePage';
import { VARIANT_BADGE_PRESET } from '../../modules/common/components/GemXVariantBadge/constants';
import { GemXVariantBadge } from '../../modules/common/components/GemXVariantBadge';
import { GemXMoreAction } from '../../modules/common/components/GemXMoreAction';
import { useEditTemplate } from '../../hooks/useEditTemplate';
import { THUMBNAIL } from '../../constants';

import useLocationHandlers from '@/composables/useLocationHandlers';

useCampaignThemePage();

const { handleOpenPageGemXInNewTab } = useLocationHandlers();
const { onEditWithTemplate } = useEditTemplate();
const { campaign, variantA, variantB, isMatchedThemePageA, isMatchedThemePageB, isThemePageAV6, isThemePageBV6 } =
  useVariantThemePage();

const activeVariant = ref<GemXOptionSelects['value']>();

const onSwitchVariant = (value: GemXOptionSelects['value']) => {
  if (!activeVariant.value || activeVariant.value === value) return;

  if (value === 'ORIGIN') {
    variantA.value && onEditWithTemplate(variantA.value);
  } else if (value === 'VARIANT') {
    variantB.value && onEditWithTemplate(variantB.value);
  }
};

watchEffect(() => {
  if (activeVariant.value) return;

  if (isMatchedThemePageA.value) {
    activeVariant.value = 'ORIGIN';
  } else if (isMatchedThemePageB.value) {
    activeVariant.value = 'VARIANT';
  }
});
</script>
<template>
  <div v-if="activeVariant" class="mr-1">
    <GemXMoreAction>
      <GemXVariantBadge
        :hidden-label="true"
        :variant="VARIANT_BADGE_PRESET[activeVariant]?.variant"
        :label="VARIANT_BADGE_PRESET[activeVariant]?.label"
        :tone="VARIANT_BADGE_PRESET[activeVariant]?.tone" />

      <template #dropdown>
        <template v-for="(item, key) in VARIANT_BADGE_PRESET" :key="item">
          <div
            class="flex cursor-pointer flex-row items-center justify-start gap-2 px-[16px] py-[12px] hover:bg-[#424242]"
            :class="{
              'opacity-40 cursor-not-allowed hover:bg-transparent':
                (key === 'ORIGIN' && !isThemePageAV6) || (key === 'VARIANT' && !isThemePageBV6),
            }"
            @click="onSwitchVariant(key)">
            <div class="flex h-5 w-5">
              <i
                v-if="key === activeVariant"
                class="icon icon-checked typo-icon-16 gfDropDownSelect__checked leading-5 text-[#42C184]"></i>
            </div>
            <GemXVariantBadge :hidden-label="true" :variant="item.variant" :label="item.label" :tone="item.tone" />
          </div>
        </template>

        <div class="h-[1px] bg-dark-200"></div>
        <div
          class="flex cursor-pointer flex-row items-center justify-center gap-2 px-[16px] py-[12px] hover:bg-[#424242]"
          @click="() => handleOpenPageGemXInNewTab(`campaign/${campaign?.id}/detail`)">
          <div class="flex h-5 w-5">
            <img :src="THUMBNAIL.THUMB_GEMX" alt="" srcset="" />
          </div>
          <h3 class="text-text-dark-500 line-clamp-1 text-xs font-semibold leading-5">Go to GemX</h3>
        </div>
      </template>
    </GemXMoreAction>
  </div>
</template>
